// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__ZC7Q5","checkbox":"Checkbox_checkbox__48bJw","checkmark":"Checkbox_checkmark__ab2pb"};